// Cmd+K (или Ctrl+K) — глобальный хоткей открытия command palette.
// Должен быть смонтирован один раз в дереве (в AppProviders).
import { useHotkey } from "@/lib/keyboard";
import { useCommandPaletteStore } from "@/stores/command-palette";

export function useCmdK(): void {
	const toggle = useCommandPaletteStore((s) => s.toggle);
	const close = useCommandPaletteStore((s) => s.close);
	const isOpen = useCommandPaletteStore((s) => s.isOpen);

	useHotkey("mod+k", () => {
		toggle();
	});
	// Esc — закрыть, если открыто.
	useHotkey(
		"escape",
		() => {
			if (isOpen) close();
		},
		{ preventDefault: false },
	);
}
